// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"ac2255ec","1422":"eb8dacdd","3140":"f1113f18","3394":"c16a4460","3756":"354bf986","5611":"354bf986","9437":"e6001b3d"}[chunkId] + ".chunk.css";
};